import { api_base_url, request } from '../utils';

const BASE = (api_base_url || '').replace(/\/+$/, '');

const toBoolean = (value) => value === true || value === 1 || value === 'true' || value === '1';

const normalizeProduct = (product) => ({
  id: product?.Id,
  title: product?.Title,
  description: product?.Description || '',
  prize: product?.Prize,
  visibleScore: toBoolean(product?.VisibleScore),
  redeemed: toBoolean(product?.Redeemed)
});

export class ExchangeProductService {
  static ENDPOINT = `${BASE}/exchangeProduct`;

  static async getAll() {
    const products = await request({
      url: `${this.ENDPOINT}/`,
      headers: { Accept: 'application/json' }
    });
    if (!Array.isArray(products)) return products;
    return products.map(normalizeProduct);
  }
}

export default ExchangeProductService;
